import React, { useEffect } from "react";
import Layout from "../../components/Layout.js";
import { IoSchool, IoStorefrontSharp } from "react-icons/io5";
import { IoIosBuild } from "react-icons/io";
import imageIllustrative5 from "../../assets/e8f087d6ee3ee0a7039e2f2f4e998012.jpg";
import imageIllustrative4 from "../../assets/sav.png";
// import Contacts from "./Contacts.jsx";

const Apropos = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll en haut
  }, []);
  return (
    <Layout>
      {/* <!-- about us --> */}

      <div className="bg-background-light dark:bg-background-dark font-display text-gray-800 dark:text-gray-200">
        <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
          {/* Main */}
          <main className="flex-grow text-black">
            {/* Hero Section */}
            <section
              className="relative h-96 bg-cover bg-center flex flex-col justify-end  items-end"
              style={{
                backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.6), transparent), url('https://lh3.googleusercontent.com/aida-public/AB6AXuCeVNKHfnlFKosvbQPE5SA0zPaLuIamEtefv58SBl17_UNKyFtmL7yVVEg7bVud4qRD6rfhpkLB1AokxO0KILnXoQawlfwnR4WBYYHOw9em7Tb51c35H34umEOMK9RviP8ET3TSAYaJVR_YbDlOBYoXm9ygixPFf-8JQevWMSKa4cfDtddjXt6YpER9ydn9tYAmAuPpGtqCSqsnyz3n_QKlTXqC6CqZ-Gk7ScXm9uxqM30N7lhESGd2XeNHPkNW9w0rNo-ts0wjeOZq')`
              }}
            >
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-">
                <h2 className="text-4xl md:text-5xl font-extrabold text-white">
                  Votre maison connectée et fonctionnelle
                </h2>
              </div>
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <h2 className="text-md md:text-xl font-medium text-white">
                  <span className="font-semibold">GODLEADERSHOP</span> –
                  L'Excellence de la Vente en ligne du Service
                </h2>
              </div>
            </section>

            <div className=" flex flex-col xl:px-[6rem] lg:px-[6rem] md:px-[2rem] px-[1rem] mx-auto text-center w-full py-16  ">
              <p className="text-gray-800 text-lg">
                Chez{" "}
                <span className="text-xl font-semibold ">GODLEADERSHOP</span>,
                nous savons que l'achat d'un appareil électroménager est un
                investissement important pour votre foyer. C'est pourquoi nous
                avons bâti notre plateforme sur un engagement double : vous
                fournir des{" "}
                <span className="font-semibold">
                  produits de qualité supérieure
                </span>{" "}
                et vous offrir des{" "}
                <span className="font-semibold">services experts</span> pour
                vous accompagner bien au-delà de la livraison.
                <br />
                {/* <br /> */}
                Nous ne vendons pas seulement des appareils ; nous vendons la{" "}
                <span className="font-semibold">tranquillité d'esprit</span>.
              </p>
            </div>

            {/* Mission */}
            <div className="container text-black mx-auto px-4 sm:px-6 lg:px-8 ">
              <h2 className="xl:text-3xl lg:text-3xl md:text-2xl text-2xl font-bold tracking-tight  text-gray-800 ">
                Notre mission
              </h2>
              <p className="mt-6  mx-auto text-lg leading-8 text-gray-800 ">
                Notre objectif est de simplifier votre quotidien en
                sélectionnant pour vous le meilleur de l'électroménager : du
                petit <span className="font-semibold">FER A REPASSER</span> au
                grand <span className="font-semibold">REFRIGERATEUR</span>.
                <br />
                <br />
                GODLEADERSHOP se distingue par son modèle intégré qui couvre
                tout le cycle de vie de vos équipements :
              </p>
            </div>

            {/* Pillars */}
            <section
              className="bg-background-light dark:bg-background-dark "
              id="pillars"
            >
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-[4rem]">
                {/* <h2 className="text-start text-3xl font-bold tracking-tight text-gray-800 ">
                  Nos pilliers
                </h2> */}
                <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-3">
                  {[
                    {
                      icon: <IoStorefrontSharp />,
                      title: "La boutique en ligne",
                      desc: " Une sélection rigoureuse des marques leaders et des produits innovants."
                    },
                    {
                      icon: <IoIosBuild />,
                      title: "le service d'Experts",
                      desc: "Une équipe de techniciens ce tient prête à intervenir pour l'installation, le dépannage, et l'entretien de vos équipements, garantissant ainsi leur longévité."
                    },
                    {
                      icon: <IoSchool />,
                      title: "Conseil et Formation ",
                      desc: "Des conseils et une formation personnalisés pour vous aider à faire les meilleurs choix et à utiliser efficacement vos produits. Nous coachons aussi tous abonnés sur l’Entrepreneuriat."
                    }
                  ].map((pillar, index) => (
                    <div
                      key={index}
                      className="flex flex-col items-center text-center p-8 bg-[#f7f6f6] rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300"
                    >
                      <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary/10 dark:bg-primary/20 text-primary">
                        <span className="material-symbols-outlined text-3xl">
                          {pillar.icon}
                        </span>
                      </div>
                      <h3 className="mt-6 text-lg font-semibold text-gray-900 ">
                        {pillar.title}
                      </h3>
                      <p className="mt-2 text-base text-gray-600 ">
                        {pillar.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Why Choose Us */}
            <section className="py-16 sm:py-24" id="why-us">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-start xl:text-3xl lg:text-3xl md:text-2xl text-2xl font-bold tracking-tight text-gray-900 ">
                  Ce Qui Fait la Différence GODLEADERSHOP
                </h2>
                <div className="mt-12 grid grid-cols-1 gap-y-12 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 sm:gap-x-6 lg:gap-x-8">
                  {[
                    {
                      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuAwjD4fK6ARkNXNsimuAL9yvwttGK1e_uIk_GgBHa5y8h-Ioe5iiQVuRfYEaa-Zsj5GURDp--JpjBvvOXn5PfU1TUNavRmfLa56ffDhdUtohVJM-ET7MJkJ_G0Z7ho3Bu3ZiIBPi6WvBolDPIw0sBrv6UC3EqpuOY0shUDv-DuxesOC4_rvmtdz1baHzytt-B8Nu-Bj9qOuL8YaVd_Cxu2-t5x9jQ1rSdYgFwktk_25DwB86a8aLHj7cCQE2dQTSCRphuABV81vh1S7",
                      title: "Sélection Qualité-Prix ",
                      desc: "Un excellent rapport qualité-prix."
                    },
                    {
                      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuAj55JhUrynNQg464UJSZIJ_wLxp5Yrz545isdgHZtNwjQQ-jGdXszfIQlp45cMPQX_t-ND8bj45wLCSMrNxouyOxPiGGdfy_T6zjiGR7Kk9mWoZJ_VGc_SJJDUExgQdZ_dv1GHEZj3I2LdEC_PQQSORR4cfikCVbWOfvQLS8s9RZDYMlUcVjKxYdoSmXBd7IQ0-J_CLdt5aLXeBA5lALFOs46q2drRpViBhD_OeS2owyU9NNqUwkapyQ2lobYb2nzO4Ou2K1-kafhn",
                      title: "Délai de Livraison",
                      desc: "Obtenez en (03H Abidjan) vos appareils rapidement."
                    },
                    {
                      img: "https://lh3.googleusercontent.com/aida-public/AB6AXuCCkdx2S5LHsHivnHf6Jjn31d6I-ZoDUqI3ykMsmNLyzK4O-eSuSaTcGGeUrsX7xq37cqS_Lknz8iXAcsCu6loWZXDl9_rDHjYln7JRPe9erkngFKAeSu13FxVBuWO6LYuW4idwGt1mJVM-cu-NXcx0Dd0Lyoz6TJmwF50s10SjpasQ4LI90clF9VlB468yT9w99_B15it18NsrAdZTYRF2L8EDgoOOl3wGjdYawWt7UCCCMPjy9N8NgCXmPPfMpoagHz9fEE1H882z",
                      title: "Installation Sans Souci ",
                      desc: "Processus d'installation sans problème."
                    },
                    {
                      img: imageIllustrative4,
                      title: "SAV Réactif et Local ",
                      desc: "Un soutien efficace quand vous en avez besoin."
                    },
                    {
                      img: imageIllustrative5,
                      title: "Conseil personalisé",
                      desc: "Des conseils d'experts pour répondre à vos besoins."
                    }
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="flex flex-col items-center text-center"
                    >
                      {/* <div
                        className="w-full aspect-square rounded-lg bg-cover bg-center"
                        style={{ backgroundImage: `url('${item.img}')` }}
                      ></div> */}
                      <img
                        src={item.img}
                        alt="sdksd"
                        className="w-full aspect-square rounded-lg bg-cover bg-center"
                      />
                      <h3 className="mt-4 text-base font-semibold text-gray-900 ">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-md xl:text-sm lg:text-sm md:text-sm text-gray-600 ">
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Call to action */}
            <section className="bg-primary/20 py-16 sm:py-24">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-3xl font-bold tracking-tight text-primary sm:text-4xl">
                  Votre Investissement, Notre Responsabilité
                </h2>
                <div className="mt-8  flex flex-col sm:flex-row gap-4 justify-center">
                  <p className="text-gray-900 text-md font-semibold">
                    Faire confiance à GODLEADERSHOP, c'est choisir un partenaire
                    qui valorise la durabilité et l'expertise technique. Nous
                    nous engageons à rendre votre expérience d'achat en ligne
                    aussi fiable que le fonctionnement de vos appareils neufs.
                    <br />
                    <br />
                    Prêt à équiper votre maison avec le meilleur de
                    l'électroménager et un service inégalé ? Découvrez notre
                    catalogue ou contactez-nous pour un devis de service !
                  </p>
                </div>
              </div>
            </section>
          </main>

          
        </div>
      </div>
      {/* Add your own content here */}
    </Layout>
  );
};

export default Apropos;
